import { Navbar, NavbarText } from 'reactstrap';
import './FooterStyle.css';

function FooterComponent() {
    return (
        <Navbar id="strong-background"
                className="my-0 "
                dark >
            <NavbarText >
                <div className= "d-flex flex-column" >
                    <div>&copy; 2025</div>
                    <div>Todos los derechos reservados</div>
                </div>
            </NavbarText>
        </Navbar>
    );
}

export default FooterComponent;